import VsMigrationSyncLogApiUrls from 'src/apiUrls/VsMigrationSyncLogApiUrls'
import VsMigrationSyncLogFormProperties from './VsMigrationSyncLogFormProperties'
import React from 'react'
import { components } from 'cng-web-lib'

const {
    form: { CngViewForm }
} = components

function VsMigrationSyncLogViewForm({
    showNotification,
    id,
    onFetchPreSuccess = () => {
        //do nothing
     },
    items
}) {
    return (
        <CngViewForm
            fieldLevel="toBeChangedByDeveloperIfWantFieldLevelRestriction"
            showNotification={showNotification}
            bodySection={
                <VsMigrationSyncLogFormProperties.Fields
                    disabled={true}
                    showNotification={showNotification}
                    items={items}
                />
            }
            formikProps={VsMigrationSyncLogFormProperties.formikProps}
            toClientDataFormat={VsMigrationSyncLogFormProperties.toClientDataFormat}
            toServerDataFormat={VsMigrationSyncLogFormProperties.toServerDataFormat}
            fetch={{
                id: id,
                url: VsMigrationSyncLogApiUrls.GET,
                onPreSuccess: onFetchPreSuccess
            }}
        />
    )
}

export default VsMigrationSyncLogViewForm
